import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  withCredentials: true, // send httpOnly cookies automatically
});

API.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export { API };

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/auth/me")
      .then(r => setUser(r.data))
      .catch(() => {}) // not logged in — stay null
      .finally(() => setLoading(false));
  }, []);

  const logout = async () => {
    try { await API.post("/auth/logout"); } catch {}
    setUser(null);
    window.location.href = "/login";
  };

  const isSuperAdmin = user?.role === "super_admin";
  const isTeamLeader = user?.role === "team_leader" || isSuperAdmin;

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout, isSuperAdmin, isTeamLeader }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
